import * as z from "zod";
import type {
  PortalSettingsPatch,
  ReturnsPortalSettingsSource,
} from "./portal-settings-source";

const TagExclusionRuleSchema = z.object({
  sourceTag: z.string(),
  excludedTags: z.array(z.string()),
});

export const exchangeAgentSettingsShape = {
  exchangeAgent: z.object({
    enabled: z.boolean(),
    displayExchangeValueAsDiscount: z.boolean(),
    variantRecommendationsEnabled: z.boolean(),
    productRecommendationsEnabled: z.boolean(),
    productRecommendationsLimit: z.number().int().min(1).max(20),
    tagExclusionRules: z.array(TagExclusionRuleSchema),
  }),
};

export type ExchangeAgentSettings = z.infer<
  z.ZodObject<typeof exchangeAgentSettingsShape>
>;

export function exchangeAgentSettingsFromTeam({
  settings,
}: ReturnsPortalSettingsSource): ExchangeAgentSettings {
  const { exchangeAgent } = settings;
  return {
    exchangeAgent: {
      enabled: exchangeAgent.enabled ?? true,
      displayExchangeValueAsDiscount:
        exchangeAgent.displayExchangeValueAsDiscount ?? true,
      variantRecommendationsEnabled:
        exchangeAgent.variantRecommendations.enabled ?? true,
      productRecommendationsEnabled:
        exchangeAgent.productRecommendations.enabled ?? true,
      productRecommendationsLimit:
        exchangeAgent.productRecommendations.limit ?? 12,
      tagExclusionRules: (
        exchangeAgent.productRecommendations.tagExclusionRules ?? []
      ).map((rule) => ({
        sourceTag: rule.sourceTag,
        excludedTags: rule.excludedTags ?? [],
      })),
    },
  };
}

export function exchangeAgentTeamPatch({
  exchangeAgent,
}: ExchangeAgentSettings): PortalSettingsPatch {
  return {
    set: {
      "exchangeAgent.enabled": exchangeAgent.enabled,
      "exchangeAgent.displayExchangeValueAsDiscount":
        exchangeAgent.displayExchangeValueAsDiscount,
      "exchangeAgent.variantRecommendations.enabled":
        exchangeAgent.variantRecommendationsEnabled,
      "exchangeAgent.productRecommendations.enabled":
        exchangeAgent.productRecommendationsEnabled,
      "exchangeAgent.productRecommendations.limit":
        exchangeAgent.productRecommendationsLimit,
      "exchangeAgent.productRecommendations.tagExclusionRules":
        exchangeAgent.tagExclusionRules,
    },
    unset: [],
  };
}
